import React from 'react';

const WithdrawRequestTr = ({ data }) => {
    return (
        <tr>
            <td data-label="ID">{data.id}</td>
            <td data-label="Date">{data.created_at}</td>
            <td data-label="Method">{data.payment_method}</td>
            <td data-label="Amount">${data.amount}</td>
            <td data-label="Fee">${data.fees}</td>
            <td data-label="Total">${data.amount-data.fees}</td>
            <td data-label="Status">{data.approved == 1 ? <span className="status-badge ok">Approved</span> : <span className="status-badge pending">Pending</span>}</td>
            <td data-label="Account Info">
                {data.payment_method == 'paypal' && data.bank_additional}
                <p className='mb-0 pb-0'>{data.payment_method == 'bank' && data.bank_name}</p>
                <p className='mb-0 pb-0'>{data.payment_method == 'bank' && data.account_number}</p>
                <p className='mb-0 pb-0'>{data.payment_method == 'bank' && data.bank_additional}</p>
                
            </td>
        </tr>
    );
};

export default WithdrawRequestTr;